import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { IAccount } from "./shared/bundles/models.bundle";

@Injectable()
export class AppData {
    focus: boolean;
    constructor() {
        this.focus = false;
    }
    // Account
    private accountSource = new BehaviorSubject(null);
    account: Observable<IAccount> = this.accountSource.asObservable();
    setAccount(account: IAccount) {
        if (account) {
            this.accountSource.next(account);
            this.applyTheme(account.theme);
        }
    }

    // Theme
    applyTheme(name?: string) {
        const theme = document.getElementById("theme").attributes;
        theme["href"].nodeValue = name ? `assets/css/template/themes/${name}.css` : "";
    }

    // VPAt 

    setFocusValue(value: boolean): boolean {
        this.focus = value;
        return this.focus;
    }

    get getFocusValue(): boolean {
        return this.focus;
    }
}